import { render, staticRenderFns } from "./EmailMessageList.vue?vue&type=template&id=3baebf02&"
import script from "./EmailMessageList.vue?vue&type=script&lang=js&"
export * from "./EmailMessageList.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VContainer,VDialog})
